define('models/Upload',[
    'lib/bluebird',
    'lib/knockout',
    'lib/lodash4',
    'services/loggingService'
], function (
    Promise,
    ko,
    _,
    loggingService
) {
    'use strict';

    function Upload(promise, metadata) {
        var self = this;

        self.bytesUploaded = ko.observable(0);
        self.totalBytes = ko.observable();
        self.metadata = ko.observable(metadata);

        self.fractionComplete = ko.computed(function () {
            if (self.totalBytes() !== undefined && self.totalBytes() > 0) {
                return self.bytesUploaded() / self.totalBytes();
            } else {
                return 0;
            }
        });

        promise
            .then(function (response) {
                loggingService.debug('Upload complete');
                return Promise.resolve(response);
            })
            .catch(Promise.CancellationError, function (error) {
                loggingService.debug('Upload aborted');
                return Promise.reject(error);
            });

        self.then = _.bind(promise.then, promise);
        self.catch = _.bind(promise.catch, promise);
        self.finally = _.bind(promise.finally, promise);
        self.cancel = _.bind(promise.cancel, promise);
    }

    return Upload;
});

